import React from 'react';

import PropTypes from 'prop-types';

import style from './container-query-layout.module.less';
import { ShipmentDetailsGridLayout } from '../shipment-details-grid-layout';

export const LayoutContainer = ({ addressColumnContent, costSummaryColumnContent, datesColumnContent, assignmentColumnContent }) => {
  return (
    <div className={style['shipment-details-grid-container']}>
      <ShipmentDetailsGridLayout
        addressColumnContent={addressColumnContent}
        assignmentColumnContent={assignmentColumnContent}
        className={style['shipment-details-grid']}
        costSummaryColumnContent={costSummaryColumnContent}
        datesColumnContent={datesColumnContent}
        dividerClassName={style['shipment-divider']}
      />
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
  datesColumnContent: PropTypes.node.isRequired,
  assignmentColumnContent: PropTypes.node.isRequired,
};
